const users = {
  users: {
    pageHeader: 'ユーザー',
    addNewUser: '+ 新規ユーザーの追加',
    name: '名称',
    role: 'ロール',
    company: '会社',
    status: 'ステータス',
    noUser: '** 該当するユーザーはいません **',
    emailMatch: 'もう一度同じ値を入力してください。',
    validEmail: '有効なメールアドレスを入力してください。',
    fieldRequired: 'このフィールドは必須です。',
    userFormHeader: '新規ユーザーの追加',
    userProfile: 'ユーザープロファイル',
    defaultEmailHelpText: 'サインイン方法を説明するメールがこのアドレスに送信されます。',
    active: 'アクティブ',
    email: 'メール',
    confirmEmail: 'メールの確認',
    firstName: '名',
    lastName: '姓',
    phoneNumber: '電話番号',
    preferredLocale: '希望地域',
    units: '単位',
    addUser: 'ユーザーの追加',
    updateUser: 'ユーザーの更新',
    supportTechnician: 'サポート技術者',
    profileAdministrator: 'プロファイル管理者',
    profileApprover: 'プロファイル承認者',
    administrator: '管理者',
    user: 'ユーザー',
    viewOnly: '閲覧のみ',
    demonstration: 'デモンストレーション',
    errorMessageLengthPhone: '最大50文字まで',
    all: 'すべて',
    inactive: '非アクティブ',
    termsAndServices: 'システム所有者のみが、自分のサイトへのアクセスを提供することができます。システム所有者の書面による承認がない場合、設置業者は他社にアクセスを提供したり、自社以外のユーザーにアクセスを提供したりすることはできません。私は、Enphaseの %{termsService} を読んで同意し、Enphaseの %{privacyPolicy} を読みました。私は、これらの条件に違反した場合、Enlightenアカウントが停止または終了する可能性があることを理解しています。',
    privacyPolicy: 'プライバシーポリシー',
    termsService: '利用規約',
  }
};

export default users;
